import { render, staticRenderFns } from "./DataPrivacyPage.vue?vue&type=template&id=4a42b2e3&scoped=true&"
import script from "./DataPrivacyPage.vue?vue&type=script&lang=ts&"
export * from "./DataPrivacyPage.vue?vue&type=script&lang=ts&"
import style0 from "./DataPrivacyPage.vue?vue&type=style&index=0&id=4a42b2e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a42b2e3",
  null
  
)

export default component.exports